<template>
  <!-- Benefit -->
  <div
    id="benefit"
    class="rows benefit"
  >
    <p class="title-section">
      Benefit Zonasea
    </p>
    <div class="row">
      <div class="col-md-4 mb-5">
        <img
          class="img-benefit"
          src="/icons/icon-noperantara.png"
          alt="icon tanpa perantara"
        >
        <div class="title-benefit">
          Tanpa Perantara
        </div>
        <div class="desc-benefit">
          Kami bekerja sama langsung dengan sejumlah pabrik terbesar di
          Indonesia
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <img
          class="img-benefit"
          src="/icons/icon_planing2.png"
          alt="icon planning otomatis"
        >
        <div class="title-benefit">
          Planning Secara Otomatis
        </div>
        <div class="desc-benefit">
          Algoritma kami dapat menghitung rute terbaik untuk kapal anda secara otomatis dalam hitungan DETIK.
        </div>
      </div>
      <div class="col-md-4 mb-5">
        <img
          class="img-benefit"
          src="/icons/icon-akurat2.png"
          alt="icon akurat persisi"
        >
        <div class="title-benefit">
          Akurat dan Presisi
        </div>
        <div class="desc-benefit">
          Memberikan informasi muatan terbaru seesuai dengan jenis & kapasitas kapal
        </div>
      </div>
    </div>
  </div>
  <!-- End Benefit -->
</template>

<script>
export default {};
</script>
